export const FETCH_LEADERBOARD_SUCCESS = 'FETCH_LEADERBOARD_SUCCESS';
export const FETCH_LEADERBOARD_IN_PROGRESS = 'FETCH_LEADERBOARD_IN_PROGRESS';
export const FETCH_LEADERBOARD_ERROR = 'FETCH_LEADERBOARD_ERROR';

export const DOWNLOAD_IV_STATS_IN_PROGRESS = 'DOWNLOAD_IV_STATS_IN_PROGRESS';
export const DOWNLOAD_IV_STATS_SUCCESS = 'DOWNLOAD_IV_STATS_SUCCESS';
export const DOWNLOAD_IV_STATS_ERROR = 'DOWNLOAD_IV_STATS_ERROR';
